import { defineMessages } from 'react-intl';

export default defineMessages({
    notYetTopupEligibleAlertText: {
        id: '_.outstanding_view.notYetTopupEligibleAlertText',
        defaultMessage:
            "You can request more funds once you've repaid {amount} - "
    },
    notYetTopupEligibleAlertDescription: {
        id: '_.outstanding_view.notYetTopupEligibleAlertDescription',
        defaultMessage:
            "You've passed our eligibility checks but your approval will still be subject to a credit review"
    },
    notYetTopupEligibleFirstRepaymentAlertText: {
        id: '_.outstanding_view.notYetTopupEligibleFirstRepaymentAlertText',
        defaultMessage: "You're almost there!"
    },
    notYetTopupEligibleFirstRepaymentAlertDescription: {
        id: '_.outstanding_view.notYetTopupEligibleFirstRepaymentAlertDescription',
        defaultMessage:
            "You'll be eligible to request more funds as soon as your first scheduled repayment is processed (usually 30 days after your loan started)."
    },
    notTopupEligibleText: {
        id: '_.outstanding_view.notTopupEligibleText',
        defaultMessage: "Sorry, you can't request more funds at the moment"
    },
    notTopupEligibleDescription: {
        id: '_.outstanding_view.notTopupEligibleDescription',
        defaultMessage:
            "isn't eligible for additional funding - feel free to give your account manager a call if you'd like to know more."
    },
    notTopupEligibleCTAText: {
        id: '_.outstanding_view.notTopupEligibleCTAText',
        defaultMessage: 'Get in touch'
    },
    topupDeclined: {
        id: '_.outstanding_view.topupDeclined',
        defaultMessage:
            'Sorry, we can’t approve you for more funds at the moment.'
    },
    preApprovedHeading: {
        id: '_.outstanding_view.preApprovedHeading',
        defaultMessage: "You've been automatically approved"
    },
    preApprovedDescription: {
        id: '_.outstanding_view.preApprovedDescription',
        defaultMessage: 'You can drawdown up to {amount} before {date}'
    },
    preApprovedCTA: {
        id: '_.outstanding_view.preApprovedCTA',
        defaultMessage: 'Choose how much'
    },
    preApprovedMoreFunds: {
        id: '_.outstanding_view.preApprovedMoreFunds',
        defaultMessage: 'Need more than {amount}?'
    },
    preApprovedMoreFundsCTA: {
        id: '_.outstanding_view.preApprovedMoreFundsCTA',
        defaultMessage: 'Request more funds'
    },
    backButtonCTA: {
        id: '_.outstanding_view.backButtonCTA',
        defaultMessage: 'Back'
    },
    requestMoreFundsHeading: {
        id: '_.outstanding_view.requestMoreFundsHeading',
        defaultMessage:
            "You're already approved for {amount}. Approval to more funds is subject to credit review."
    },
    topupEligibleTitle: {
        id: '_.outstanding_view.topupEligibleTitle',
        defaultMessage: 'Need more funds?'
    },
    topupEligibleDescription: {
        id: '_.outstanding_view.topupEligibleDescription',
        defaultMessage:
            'You can now request more funds - approval is subject to credit review'
    },
    createTopupRequestCTAText: {
        id: '_.outstanding_view.createTopupRequest',
        defaultMessage: 'Request more funds'
    }
});
